import { Asterisk } from "lucide-react";

const ITEMS = [
  "Gutter Cleans",
  "Gutter Repairs",
  "Gutter Replacements",
  "Roof Cleans",
  "Roof Paints",
  "Roof Replacements",
  "022 547 7534",
  "Servicing all of Taranaki",
  "New Plymouth → Hāwera",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-ticker"
      aria-hidden="true"
      className="overflow-hidden border-y border-white/10 bg-[#0D1320] py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center">
            {ITEMS.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="px-8 font-mono text-sm uppercase tracking-[0.3em] text-slate-500">{item}</span>
                <Asterisk className="h-4 w-4 shrink-0 text-orange-500/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
